import type { ModalOverlayProps as ChakraModalOverlayProps } from '@chakra-ui/react';
import { ModalOverlay as ChakraModalOverlay } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type ModalOverlayProps = OmitChakraProps<
  ChakraModalOverlayProps,
  'motionProps' | 'children'
>;

export const ModalOverlay = withChakraAs<ModalOverlayProps, 'div'>((props) => {
  return <ChakraModalOverlay {...props} />;
});
